import { ProjectActions } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { commitProjectRequest } from '@storeOld/actionCreators'
import {
  NotificationType,
  notificationActionCreators,
} from '@storeOld/reducers/notification'
import cx from 'classnames'
import type React from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import API from '@/api'
import { isFigma } from '@/helpers'
import IconRefresh from '../../icons/IconRefresh'
import css from './Refresh.module.scss'

type Props = {
  nodeId: string
  url: string
}

const Refresh: React.FC<Props> = ({ nodeId, url }) => {
  const dispatch = useDispatch()

  const [refreshing, setRefreshing] = useState(false)

  const projectId = useSelector(migrationProjectSelector.getProjectId)

  const onClick = async (e: React.MouseEvent) => {
    e.stopPropagation()

    setRefreshing(true)

    const {
      groups: { key, node, key2, node2 },
    }: any = isFigma.exec(url)

    try {
      const requestId = node
        ? node.replace('-', '%3A')
        : node2.replace('-', '%3A')

      const res = await API.Projects.getFigmaDocument(projectId, {
        fileId: key || key2,
        nodeId: requestId,
      })

      dispatch(
        commitProjectRequest(
          ProjectActions.nodes.setFigmaPreview({
            id: nodeId,
            figma: {
              figmaUrl: url,
              page: res.page,
              project: res.project,
              preview: res.previewUrl,
              thumbnail: res.thumbnailUrl,
            },
          })
        )
      )
    } catch {
      dispatch(
        notificationActionCreators.setNotification({
          type: NotificationType.SOMETHING_WENT_WRONG_ERROR,
        })
      )
    } finally {
      setRefreshing(false)
    }
  }

  return (
    <div className={css.container}>
      <div
        className={cx(css.button, {
          [css.refreshing]: refreshing,
        })}
        onClick={onClick}
      >
        <IconRefresh />
      </div>
    </div>
  )
}

export default Refresh
